import React from 'react'
import { Link } from 'react-router-dom'
import Fade from 'react-reveal/Fade';

function Corporatebox() {
    return (
        <div className='corporate-details-section'>
            <div className='container'>
                {/* Section Header */}
                <Fade down delay={200}>
                    <div className='corporate-section-header'>
                        <div className='header-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg>
                        </div>
                        <h2 className='corporate-main-title'>Salaam Takaful Limited</h2>
                        <p className='corporate-subtitle'>Company Information & Registration Details</p>
                    </div>
                </Fade>

                {/* Info Cards Grid */}
                <div className='corporate-cards-grid'>
                    <Fade up delay={300}>
                        <div className='corporate-info-card'>
                            <div className='card-icon-wrapper'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                            </div>
                            <div className='card-content'>
                                <span className='card-label'>Company Status</span>
                                <h4 className='card-value'>Large Scale Company (LSC)</h4>
                            </div>
                        </div>
                    </Fade>

                    <Fade up delay={400}>
                        <div className='corporate-info-card'>
                            <div className='card-icon-wrapper'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                </svg>
                            </div>
                            <div className='card-content'>
                                <span className='card-label'>Company Incorporation No.</span>
                                <h4 className='card-value'>0056567</h4>
                            </div>
                        </div>
                    </Fade>

                    <Fade up delay={500}>
                        <div className='corporate-info-card'>
                            <div className='card-icon-wrapper'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                </svg>
                            </div>
                            <div className='card-content'>
                                <span className='card-label'>Company Incorporation Date</span>
                                <h4 className='card-value'>2nd June, 2006</h4>
                            </div>
                        </div>
                    </Fade>

                    <Fade up delay={600}>
                        <div className='corporate-info-card'>
                            <div className='card-icon-wrapper'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                    <polyline points="10 9 9 9 8 9"></polyline>
                                </svg>
                            </div>
                            <div className='card-content'>
                                <span className='card-label'>National Tax Number (NTN)</span>
                                <h4 className='card-value'>2668683-0</h4>
                            </div>
                        </div>
                    </Fade>

                    <Fade up delay={700}>
                        <div className='corporate-info-card corporate-download-card'>
                            <div className='card-icon-wrapper download-icon'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="7 10 12 15 17 10"></polyline>
                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                </svg>
                            </div>
                            <div className='card-content'>
                                <span className='card-label'>Certificate of Incorporation</span>
                                <Link
                                    to={`${process.env.REACT_APP_URL_ASSETS}Assets/pdf/CertificateofIncorporation.pdf`}
                                    target='_blank'
                                    className='download-link'
                                >
                                    <span className='file-name'>Certificate.pdf</span>
                                    <span className='download-btn'>
                                        Download
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                            <polyline points="7 10 12 15 17 10"></polyline>
                                            <line x1="12" y1="15" x2="12" y2="3"></line>
                                        </svg>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </Fade>
                </div>
            </div>
        </div>
    )
}

export default Corporatebox